import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Reveal } from "./Reveal";
import { api } from "../lib/api";
import emblem from "../assets/banner.png";

export default function Footer({ contactEmail = "support@driftbaitco.com" }) {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    api.get("/products/categories").then((r) => setCategories((r.data || []).filter((c) => c.toLowerCase() !== "all"))).catch(() => {});
  }, []);

  return (
    <footer className="relative bg-[#04070A] border-t border-white/5 pt-24 pb-10" data-testid="footer">
      <div className="max-w-[1600px] mx-auto px-6 md:px-10">
        <Reveal>
          <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-10 pb-20">
            <div>
              <p className="font-mono-plex text-xs tracking-[0.25em] uppercase text-orange-500 mb-6">
                Tight lines
              </p>
              <h2 className="font-display text-5xl sm:text-7xl lg:text-8xl uppercase tracking-tighter leading-[0.85]">
                Rig up<br />and drift.
              </h2>
            </div>
            <a
              href={`mailto:${contactEmail}`}
              className="font-mono-plex text-sm tracking-widest uppercase text-slate-300 hover-underline pb-1"
              data-testid="footer-email"
            >
              {contactEmail}
            </a>
          </div>
        </Reveal>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 border-t border-white/5 pt-10">
          <div className="col-span-2">
            <img src={emblem} alt="Drift Tackle Co. emblem" className="h-28 w-28 object-contain mix-blend-screen -ml-2" />
            <p className="mt-4 text-slate-500 text-sm max-w-xs leading-relaxed">
              Hand-poured soft plastics engineered for anglers who read the water. Built in the north, proven everywhere.
            </p>
          </div>
          <div className="flex flex-col gap-3">
            <span className="font-mono-plex text-xs tracking-[0.2em] uppercase text-slate-500 mb-1">Shop</span>
            <Link to="/shop" className="text-slate-300 text-sm hover:text-orange-500 transition-colors">All Baits</Link>
            {categories.slice(0, 4).map((c) => (
              <Link key={c} to={`/shop?category=${encodeURIComponent(c)}`} className="text-slate-300 text-sm hover:text-orange-500 transition-colors" data-testid={`footer-cat-${c.toLowerCase()}`}>{c}</Link>
            ))}
          </div>
          <div className="flex flex-col gap-3">
            <span className="font-mono-plex text-xs tracking-[0.2em] uppercase text-slate-500 mb-1">Info</span>
            <Link to="/story" className="text-slate-300 text-sm hover:text-orange-500 transition-colors">Our Story</Link>
            <Link to="/admin/login" className="text-slate-300 text-sm hover:text-orange-500 transition-colors" data-testid="footer-admin-link">Admin</Link>
          </div>
        </div>

        <div className="mt-16 flex flex-col sm:flex-row justify-between gap-3 text-slate-600 text-xs font-mono-plex tracking-widest uppercase">
          <span>© {new Date().getFullYear()} Drift Tackle Co.</span>
          <span>Field tested · Water proven</span>
        </div>
      </div>
    </footer>
  );
}
